import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import Bannerfrom from "../components/bannerfrom";
import {Link} from 'gatsby';

function Banner(props) {
    return (
        <div className="services_location_banner">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={6} lg={6} xl={7} xxl={7} className="my-auto">
                        <div className="banenr_content">
                            <div className="example" data-text="Dallas">
                                <h1>Custom Software Development Company In <span>Dallas</span></h1>
                            </div>
                            <p className="main_para">Scale your business and increase ROI by acquiring top digital products through a performance-focused software development company in Dallas. Work with the best technical and strategic resources on board ready, to cater to your project at the first call.</p>
                            <Link to="/contact"
                            className="border_btn" aria-label="TekRevol Contact"> Let’s Get Started</Link>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={5} xxl={5} className="my-auto">
                        <Bannerfrom/>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Banner;